import actions from '@/core/store/fornecedor/actions'
import mutations from '@/core/store/fornecedor/mutations'
import state from '@/core/store/fornecedor/state'

export default { actions, mutations, state }
